import api from "@/api/axios/axios.js";

// Inicia el enrolamiento: devuelve { otpauth_uri, secret } para pintar el QR.
export async function mfaSetup(mfaToken) {
  const { data } = await api.post("/login/mfa/setup/", { mfa_token: mfaToken });
  return data;
}

// Confirma el enrolamiento con el codigo de la app.
// Devuelve { mfa_enabled, recovery_codes } (mostrar recovery_codes una sola vez).
export async function mfaConfirm(mfaToken, code) {
  const { data } = await api.post("/login/mfa/confirm/", {
    mfa_token: mfaToken,
    code,
  });
  return data;
}

// Verifica el codigo (o un recovery_code) y deja la sesion (cookies).
export async function mfaVerify(mfaToken, { code, recoveryCode } = {}) {
  const payload = { mfa_token: mfaToken };
  if (code) payload.code = code;
  if (recoveryCode) payload.recovery_code = recoveryCode;
  const { data } = await api.post("/login/mfa/verify/", payload);
  return data;
}

// Desactiva MFA (requiere sesion). Va en Perfil/ajustes, no en login.
export async function mfaDisable(password) {
  const { data } = await api.post("/login/mfa/disable/", { password });
  return data;
}
